import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { noop } from 'ui-components/default-props/noop';

const messages = defineMessages({
  title: {
    description: 'Products Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'E+tyKa',
  },
  description: {
    description: 'Products Placeholder Description',
    defaultMessage: 'No Products data to view at the moment',
    id: '1FkM/m',
  },
  boldStatusView: {
    description: 'Products Placeholder Bold Status View Name',
    defaultMessage: 'Products',
    id: '6xwsPM',
  },
});

const ProductsGridPlaceholder = () => {
  return (
    <ActionablePlaceholder
      action={noop}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default ProductsGridPlaceholder;
